@if (isLoading$ | async) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}